import { SVG, SVGProps } from './svg'

export function IconDrawingSettingShow(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M7.9 23.4 23.4 8l.7.7L8.6 24l-.7-.7Zm7-4.1a3.5 3.5 0 0 0 4.4-4.5l-.8.8v.4a2.5 2.5 0 0 1-2.9 2.5l-.8.8Zm1.5-5.8H16a2.5 2.5 0 0 0-2.5 2.9l-.8.8a3.5 3.5 0 0 1 4.5-4.5l-.8.8Zm-.4 10c-1.5 0-3-.5-4.2-1.2l.7-.7c1.1.5 2.3.9 3.5.9 2.6 0 5-1.6 6.7-3.4a22 22 0 0 0 2.7-3V16a19.9 19.9 0 0 0-3.4-3.8l.7-.7a19.3 19.3 0 0 1 3.7 4.2l-.4.3.4.3a5.3 5.3 0 0 1-.2.3 20.8 20.8 0 0 1-2.8 3.3c-1.8 1.7-4.4 3.6-7.4 3.6ZM26 16l.4-.3.2.3-.2.3-.4-.3ZM16 9.5c1.2 0 2.4.4 3.5 1l.7-.8A8.6 8.6 0 0 0 16 8.5c-3 0-5.6 1.9-7.4 3.6a23 23 0 0 0-3 3.6l.4.3-.4-.3-.2.3.2.3.4-.3-.4.3a7.3 7.3 0 0 0 .2.3 20.8 20.8 0 0 0 3.5 4l.7-.8A18.2 18.2 0 0 1 6.6 16a19.8 19.8 0 0 1 2.7-3.1C11 11 13.4 9.5 16 9.5Z"
      />
    </SVG>
  )
}
